export const inviteShareIconOptions = {
  height: '25px',
};

export const inviteShareMobileIconOptions = {
  height: '14px',
};
